import { useRef } from 'react';

export const useTimer = () => {
  const prevTimeRef = useRef<number>(undefined);
  const currentTimeRef = useRef<number>(Date.now());

  const check = () => {
    const newTime = Date.now();
    const difference = prevTimeRef.current
      ? newTime - currentTimeRef.current
      : undefined;

    prevTimeRef.current = currentTimeRef.current;
    currentTimeRef.current = newTime;

    return difference;
  };

  return {
    check,
  };
};
